import React, { useContext } from "react";

// Styling
import "../../Styles/MainPage.scss";

// Material UI stuff
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import NavbarLeft from "./NavbarLeft";

// Global state
import { StateContext } from "../../AppStateContext";

import clsx from "clsx";

// Components
import NavbarRight from "./NavbarRight";

const Navbar = ({ classes }) => {
  // Consuming global state
  const state = useContext(StateContext);

  return (
    <div>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: state.isSidebarOpen,
        })}
      >
        <Toolbar>
          <div className="__Navbar">
            <NavbarLeft />
            <NavbarRight />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Navbar;
